import http from '../../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_COMMON}`

const department = (form = {}) => http.post(`${api}/department`, form)

export default department
